import { isObservable } from 'rxjs';
import { useState, useRef, useDebugValue } from 'react';
import { useSubscription } from './use-subscription';
import { useRefFn, getEmptySubject } from './helpers';
export function useObservableState(state$OrInit, initialState) {
    var _a = useState(initialState), state = _a[0], setState = _a[1];
    var callback;
    var state$;
    if (isObservable(state$OrInit)) {
        state$ = state$OrInit;
    }
    else {
        var init_1 = state$OrInit;
        // Even though hooks are under conditional block
        // it is for a completely different use case
        // which unlikely coexists with the other one.
        // A warning is also added to the docs.
        var input$Ref_1 = useRefFn(getEmptySubject);
        state$ = useRefFn(function () { return init_1(input$Ref_1.current, state); }).current;
        callback = useRef(function (state) { return input$Ref_1.current.next(state); }).current;
    }
    useSubscription(state$, setState);
    // Display state in React DevTools.
    useDebugValue(state);
    return callback ? [state, callback] : state;
}
//# sourceMappingURL=use-observable-state.js.map